import React from 'react';
import { WeezHeader, Button, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { fetcher } from '@weezevent/weezjs-core';
import { requiredField, useForm } from '../../../../utils/validators';
import TicketOfficeParametersForm from './ticketOfficeParametersForm';

export default function TicketOfficeParameters({ organization, ticket_office, syncTicketOffice, hasModerationEnabled }) {
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const [isSubmitting, setSubmitting] = React.useState(false);

    const validators = React.useMemo(() => {
        return {
            name: requiredField
        };
    }, []);

    const [ticketOfficeSettingsForm, setTicketOfficeSettingsForm, setTicketOfficeSettingsFormObject, ticketOfficeErrors] = useForm(
        {
            organization_id: organization.id,
            name: ticket_office.name,
            add_new_events: ticket_office.add_new_events,
            quota_set_default: ticket_office.quota_set_default,
            quota_max_default: ticket_office.quota_max_default,
            accept_booking: ticket_office.accept_booking,
            accept_promotions_default: ticket_office.accept_promotions_default,
            send_copy_paidout: ticket_office.send_copy_paidout,
            allow_refund: ticket_office.allow_refund,
            allow_order_deletion: ticket_office.allow_order_deletion,
            allow_invoice_printing: ticket_office.allow_invoice_printing,
            accept_all_transaction: ticket_office.accept_all_transaction,
            accept_all_stats: ticket_office.accept_all_stats,
            counter_printing: ticket_office.counter_printing,
            render_quotas: ticket_office.render_quotas,
            type_placement: ticket_office.type_placement,
            display_only_approved_attendee: ticket_office.display_only_approved_attendee
        },
        validators
    );

    const handleSubmit = React.useCallback(() => {
        setSubmitting(true);
        fetcher
            .patch(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}`, { data: ticketOfficeSettingsForm })
            .then(() => {
                toast.success(t('ticket.ticket_offices.parameters.toast.success'));
                syncTicketOffice({
                    allow_cache: false,
                    cache: false
                });
            })
            .catch(() => {
                toast.error(t('ticket.ticket_offices.parameters.toast.error'));
            })
            .finally(() => {
                setSubmitting(false);
            });
    }, [organization, ticket_office, ticketOfficeSettingsForm, toast]);

    return (
        <>
            <WeezHeader
                title={t('ticket.ticket_offices.parameters.pageTitle')}
                rightComponent={[
                    <Button primary key={0} label={t('ticket.common.action.save')} onClick={handleSubmit} disabled={isSubmitting || Object.keys(ticketOfficeErrors).length > 0} />
                ]}
            >
                {t('ticket.ticket_offices.parameters.header_description')}
            </WeezHeader>
            <TicketOfficeParametersForm
                hasModerationEnabled={hasModerationEnabled}
                ticketOfficeSettingsForm={ticketOfficeSettingsForm}
                setTicketOfficeSettingsForm={setTicketOfficeSettingsForm}
                setTicketOfficeSettingsFormObject={setTicketOfficeSettingsFormObject}
                formErrors={ticketOfficeErrors}
            />
        </>
    );
}
